import { HTTPStatusCodes } from '@omnipresentgroup/constants';
import type { GetContractorPaymentResponseAPI } from '@omnipresentgroup/types';
import { HttpResponse, http } from 'msw';

import { API_PATH } from './constants';
import { PAYMENT_WITH_MULTIPLE_BREAKDOWNS } from './fixtures';

export const paymentHandlers = [
  http.post<{ id: string }, never, never>(`*/${API_PATH}/:id/cancel`, () => {
    return HttpResponse.json(
      {},
      {
        status: HTTPStatusCodes.OK,
      },
    );
  }),
  http.get<{ id: string }, never, GetContractorPaymentResponseAPI>(
    `*/${API_PATH}/:id`,
    async () => {
      return HttpResponse.json(PAYMENT_WITH_MULTIPLE_BREAKDOWNS, {
        status: HTTPStatusCodes.OK,
      });
    },
  ),
];
